const topics = [
  { name: '创造营2026三公', heat: '🔥 286万讨论', tag: '爆' },
  { name: '电竞世界杯预选', heat: '189万讨论', tag: '热' },
  { name: '歌手2026赛制改革', heat: '157万讨论', tag: '热' },
  { name: '街舞大赛评分争议', heat: '134万讨论', tag: '热' },
  { name: 'AI创作边界讨论', heat: '98万讨论', tag: '新' },
  { name: '美食大赛冠军回归', heat: '87万讨论', tag: '新' },
  { name: '选秀黑马逆袭', heat: '76万讨论', tag: '新' },
  { name: '大赛吃瓜名场面', heat: '65万讨论', tag: '荐' },
  { name: '转会市场大瓜', heat: '58万讨论', tag: '' },
  { name: '训练生日常爆料', heat: '43万讨论', tag: '' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            话题热榜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">全网大赛吃瓜热门话题，看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer flex items-center gap-3 bg-background-50 rounded-full px-5 py-3 hover:bg-primary-50 transition-colors duration-200"
            >
              {item.tag && (
                <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-500 text-white' :
                  item.tag === '热' ? 'bg-accent-500 text-white' :
                  item.tag === '新' ? 'bg-secondary-500 text-white' :
                  'bg-secondary-200 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="text-sm text-foreground-800 font-medium group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                #{item.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}